/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ERRORS } from './Error.constants';
import { ErrorWithHttpStatusCode } from './ErrorWithHttpStatusCode';

/**
 * Not implemented error (501).
 * @export
 * @class NotImplementedError
 * @extends {ErrorWithHttpStatusCode}
 */
export class NotImplementedError extends ErrorWithHttpStatusCode {
  constructor(
    public details: string,
    message = ERRORS.notImplemented.name,
  ) {
    super(ERRORS.notImplemented.code, message, details);
  }
}
